import { ArticleStatus } from '../enums/Article'

/**
 * Article List
 */

export const MAX_ARTICLES_CSV_ROWS = 10000

export const ITEMS_PER_PAGE_OPTIONS = [
  { text: '50', value: 50 },
  { text: '100', value: 100 },
  { text: '300', value: 300 },
  { text: '500', value: 500 },
  { text: '1000', value: 1000 },
]

export const DEFAULT_ITEMS_PER_PAGE = 300

export const ARTICLES_CHANGE_DATA = [
  {
    icon: 'unhide',
    header: '選択された記事のステータスを変更',
    content: '選択された記事を公開します。',
    type: 'status',
    status: ArticleStatus.PUBLISH,
    button: {
      positive: true,
      negative: false,
      content: '公開にする',
    },
  },
  {
    icon: 'hide',
    header: '選択された記事のステータスを変更',
    content: '選択された記事を保留にします。',
    type: 'status',
    status: ArticleStatus.PENDING,
    button: {
      positive: true,
      negative: false,
      content: '保留にする',
    },
  },
  {
    icon: 'wait',
    header: '選択された記事のステータスを変更',
    content: '選択された記事を下書きに戻します。',
    type: 'status',
    status: ArticleStatus.DRAFT,
    button: {
      positive: true,
      negative: false,
      content: '下書きに戻す',
    },
  },
  {
    icon: 'trash',
    header: '選択された記事のステータスを変更',
    content: '選択された記事をゴミ箱へ移動します。',
    type: 'status',
    status: ArticleStatus.TRASH,
    button: {
      positive: false,
      negative: true,
      content: 'ゴミ箱へ移動',
    },
  },
  {
    icon: 'exchange',
    header: '選択された記事のデータを変更',
    content: 'ここから記事カテゴリの一括変更できます。',
    type: 'category',
    status: null,
    button: {
      positive: true,
      negative: false,
      content: '変更する',
    },
  },
  {
    icon: 'redriver',
    header: '校閲(重複、元記事、関連記事)を実行します。',
    content: '校閲(重複、元記事、関連記事)を実行します。',
    type: 'system-audit',
    status: null,
    button: {
      positive: true,
      negative: false,
      content: '校閲を実行',
    },
  },
]

/**
 * Article Detail
 */

export const PUBLISH_ARTICLE_REQUIRE_ATTRIBUTES = [
  'title',
  'description',
  'mediumId',
  'mediumItemId',
  'thumbnailImageUrl',
]
